const minWidths = {
    xs: 0,
    sm: 480,
    md: 768,
    lg: 992,
    xl: 1440,
};

const screenSize = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
};

const screenType = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop',
};

const browserUtils = {
    minWidths,
    screenSize,
    screenType,
    removeElementById(id) {
        const elem = document.getElementById(id);

        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    },
    screen: {
        width() {
            if (typeof window !== 'undefined') {
                return window.innerWidth && document.documentElement.clientWidth ?
                    Math.min(window.innerWidth, document.documentElement.clientWidth) :
                    window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth;
            }
            return null;
        },
        size(width = screen.width()) {
            if (width < minWidths.sm) {
                return screenSize.XS;
            }
            if (width < minWidths.md) {
                return screenSize.SM;
            }
            if (width < minWidths.lg) {
                return screenSize.MD;
            }
            if (width < minWidths.xl) {
                return screenSize.LG;
            }
            if (width >= minWidths.xl) {
                return screenSize.XL;
            }
            return null;
        },
        type(size = screen.size()) {
            switch (size) {
                case screenSize.XS:
                case screenSize.SM:
                case screenSize.MD:
                    return screenType.MOBILE;
                case screenSize.LG:
                    return screenType.TABLET;
                case screenSize.XL:
                    return screenType.DESKTOP;
                default:
                    return null;
            }
        },
    },
};

browserUtils.screen.width = browserUtils.screen.width.bind(browserUtils);
browserUtils.screen.size = browserUtils.screen.size.bind(browserUtils);
browserUtils.screen.type = browserUtils.screen.type.bind(browserUtils);

export default browserUtils;
